import React from 'react'

import { Formik } from 'formik'

import { Button } from '_zari/core'

import * as FormGroups from './formGroups'

const FilaTemplate = ({
  index,
  defaultData,
  actualizarFilaHandler,
  flagUltimo,
  montoBase,
  clickEliminarSustraccion
}) => {
  const formInitialValues = React.useMemo(() => {
    return {
      index: index,
      porcentaje: defaultData.porcentaje || '',
      _idSustraccionVenta: defaultData._idSustraccionVenta || '',
      monto: defaultData.monto || ''
    }
  }, [index, defaultData])

  const clickEliminar = React.useCallback(() => {
    clickEliminarSustraccion({ index: index })
  }, [clickEliminarSustraccion, index])

  return (
    <Formik initialValues={formInitialValues}>
      {({ isSubmitting, errors, touched, values, handleBlur, handleChange, setValues }) => (
        <tr>
          <td>
            <FormGroups.TipoSustraccionVentaFormGroup
              iTouched={touched.fecha}
              iError={errors.fecha}
              fIsSubmitting={isSubmitting}
              index={index}
              values={values}
              actualizarFilaHandler={actualizarFilaHandler}
              handleChange={handleChange}
              setValues={setValues}
              montoBase={montoBase}
            />
          </td>
          <td>
            <FormGroups.PorcentajeFormGroup index={index} />
          </td>
          <td>
            <FormGroups.MontoFormGroup
              iTouched={touched.monto}
              iError={errors.monto}
              fIsSubmitting={isSubmitting}
              index={index}
              handleBlur={handleBlur}
              values={values}
              actualizarFilaHandler={actualizarFilaHandler}
              flagUltimo={flagUltimo}
            />
          </td>
          <td>
            <Button color='danger' onClick={clickEliminar}>
              Eliminar
            </Button>
          </td>
        </tr>
      )}
    </Formik>
  )
}

export default React.memo(FilaTemplate)
